export const SUPPORTED_LOCALES = ['zh-CN', 'en', 'ja', 'zh-TW']

export const DEFAULT_LOCALE = import.meta.env.MODE === 'jp-app' ? 'ja' : 'en'

export const LOCALE_LABELS_ZH = {
  'zh-CN': '简体中文',
  en: '英文',
  ja: '日文',
  'zh-TW': '繁体中文'
}

export function resolveLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
}
